import React from 'react';

import Modal from '../Fragments/Modal';


const CompareProductsModal = React.createClass({

    getInitialState() {
        return {
            showModal: false
        };
    },

    showModal(e) {
        e.preventDefault();
        this.setState({
            showModal: true
        });
    },

    closeModal(e) {
        e.preventDefault();
        this.setState({
            showModal: false
        });
    },

    render() {
        return (
            <div>
                <p className="product-cover-supplemental">Not sure which cover to choose? <a onClick={this.showModal} className="underline">Quickly compare cover</a></p>
                <Modal
                    title="Compare Products"
                    isActive={this.state.showModal}
                    closeFunction={this.closeModal}
                    bodyTemplate="compare-product"
                    hasFooter={true}
                />
            </div>

        );
    }
});

export default CompareProductsModal;



/** WEBPACK FOOTER **
 ** ./src/components/Modals/CompareProducts.js
 **/